import { createFileRoute } from '@tanstack/react-router';
import DocsGroupSectionLanding from '@/components/Docs/DocsGroupSectionLanding';

export const Route = createFileRoute('/about-legal/$section/')({
  component: AboutLegalSectionLandingPage,
});

function AboutLegalSectionLandingPage() {
  const { section } = Route.useParams();
  return <DocsGroupSectionLanding group="about-legal" sectionSlug={section} />;
}
